import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C5TransactionsEdit } from "./edit";
import { C5TransactionsNew } from "./new";
import { C5TransactionsTable } from "./table";

export default function C5Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C5TransactionsEdit />} />
      <Route index element={<C5TransactionsTable />} />
      <Route path="/new" element={<C5TransactionsNew />} />
    </Routes>
  );
}
